import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { Button, Type } from '@americanexpress/aqx-components';

import { makeGetCardData, getUpgradeCta } from '../redux';
import { hasPznDataArrived } from 'src/universal/redux/pznData';

import { createCombinedApplyHandler } from 'src/universal/utils/applyOfferGatingHandler';
import {
  mapUrlWithDtmLinkQuery,
  sendDTMClickEvent
} from 'service_modules/models/dtm-tagging';
import removeTagsAndTheirContent from 'service_modules/utils/text-remove-tags.js';
import styles from '../__styles__/applyOrUpgradeCta.scss?modules';

/*
US5660989: this component will produce one of the 2 results below:
(1) If the user is a CM and his/her card is eligible for an upgrade, it
    produces 2 CTAs: Upgrade cta and Apply cta.
(2) Otherwise, it produces only one CTA: the Apply cta.
Note: the above is an existing behavior currently being supported on
      PDP and VAC pages. This story is to correct (and finish off) the
      "imcompleteness" of this module.
*/
const ApplyOrUpgradeCta = ({
  pznArrived,
  upgradeCta,
  cardData,
  position = 'Top'
}) => {
  if (!pznArrived) return <div className={styles.placeholder} />;

  const { needUpgradeCta, upgradeBtn } = upgradeCta;

  const renderUpgradeCta = position !== 'Top' && needUpgradeCta;

  const applyButton = {
    ...(cardData?.links?.apply || {})
  };

  const makeDtm = ctaType => {
    return {
      eventAction: 'click',
      eventType: 'pageInteraction',
      type: 'intlink',
      eventAsset: `${ctaType}_${position}_${cardData.dtmProductName}`,
      tag: `${ctaType}_${cardData.dtmProductName}_${position}`
    };
  };

  const dtmApply = makeDtm('Apply');
  const dtmUpgrade = makeDtm('Upgrade');
  applyButton.url = mapUrlWithDtmLinkQuery(applyButton.url, dtmApply);
  applyButton.dtm = dtmApply;
  upgradeBtn.dtm = dtmUpgrade;

  const clsApply = renderUpgradeCta ? styles.ctaSecondary : styles.cta;
  const readableCardTitle = removeTagsAndTheirContent(cardData.cardTitle);

  return (
    <>
      {renderUpgradeCta && (
        <Button
          Component="a"
          className={clsx(styles.cta, styles.isUpgrade)}
          $type={Type.Primary}
          title={upgradeBtn.text}
          href={upgradeBtn.url}
          aria-label={`${upgradeBtn.text} for ${readableCardTitle}`}
          onClick={() => {
            sendDTMClickEvent(upgradeBtn.dtm);
          }}
        >
          <p>{upgradeBtn.text}</p>
        </Button>
      )}
      <Button
        Component="button"
        className={clsx(clsApply)}
        $type={renderUpgradeCta ? Type.Secondary : Type.Primary}
        title={applyButton.text}
        href={applyButton.url}
        aria-label={`${applyButton.text} for ${readableCardTitle}`}
        onClick={createCombinedApplyHandler({
          linkDef: applyButton,
          card: cardData,
          pagePznId: 'open_cc',
          cmPznEventInfo: upgradeCta.cmPznEventInfo,
          modalName: `apply_${cardData.shortName}`
        })}
      >
        <p>{applyButton.text}</p>
      </Button>
    </>
  );
};

const mapStateToProps = () => {
  const getCardData = makeGetCardData();
  return (state, { shortName }) => ({
    cardData: getCardData(state, shortName),
    upgradeCta: getUpgradeCta(state, shortName),
    pznArrived: hasPznDataArrived(state)
  });
};

export default connect(mapStateToProps)(ApplyOrUpgradeCta);
